import React from 'react'
import moment from 'moment'
import {ReservationContext} from '../../../../context/Reservation'
import {useMemo} from 'react'

const PopEventDisplayItem = ({item, onClickEvent}) => {
  const {indicator, background} = useMemo(() => {
    const start_date = moment(item.start)
    const end_date = moment(item.end)
    let sameday = start_date.isSame(end_date, 'day')

    let indicator = sameday ? 'circle' : 'bar'

    let background = sameday ? '#fff' : `${item.color}3f`

    return {indicator, background}
  }, [item])

  return (
    <div
      key={item.id}
      className="c-pop-event-display__item ap-typography ap-typography--xs "
      style={{
        backgroundColor: background,
      }}
      title={item.title}
      onClick={e => onClickEvent(e, item)}
    >
      {indicator === 'bar' && (
        <div
          className="c-pop-event-display__item-indicator--bar"
          style={{background: item.color}}
        />
      )}
      {indicator === 'circle' && (
        <div
          className="c-pop-event-display__item-indicator--circle"
          style={{background: item.color}}
        />
      )}
      <span className="ap-ellipsis">{item.title}</span>
    </div>
  )
}

export default PopEventDisplayItem
